import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, ArrowLeft, Users } from 'lucide-react';
import { Button } from '../components/ui/button';
import { IndividualMessagesTable } from '../components/IndividualMessagesTable';
import { EmailPreviewModal } from '../components/EmailPreviewModal';

export default function IndividualMessageReview() {
  const navigate = useNavigate();
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);

  const handlePreview = (message) => {
    setSelectedMessage(message);
    setPreviewOpen(true);
  };

  const handleClosePreview = () => {
    setPreviewOpen(false);
    setSelectedMessage(null);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-white shadow-sm rounded-lg border border-gray-200 p-6">
        <div className="flex items-center justify-between">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <Button
                onClick={() => navigate('/email-campaigns')}
                variant="ghost"
                size="sm"
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Volver
              </Button>
            </div>
            <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
              <Users className="h-8 w-8 text-indigo-600" />
              Revisión de Mensajes Individuales
            </h1>
            <p className="text-gray-600 mt-2">
              Gestiona y aprueba cada mensaje personalizado antes de enviarlo
            </p>
          </div>
        </div>
      </div>

      {/* Información */}
      <div className="bg-indigo-50 border-l-4 border-indigo-400 p-4 rounded-lg">
        <div className="flex">
          <div className="flex-shrink-0">
            <Mail className="h-5 w-5 text-indigo-600" />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-indigo-800">
              Sistema de Mensajes Personalizados
            </h3>
            <div className="mt-2 text-sm text-indigo-700">
              <ul className="list-disc list-inside space-y-1">
                <li><strong>Previsualizar:</strong> Ver el email con los datos reales del destinatario</li>
                <li><strong>Aprobar:</strong> Autorizar el envío del mensaje individual</li>
                <li><strong>Enviar Ahora:</strong> Encolar mensaje para envío inmediato</li>
                <li><strong>Scheduler:</strong> Los mensajes aprobados se enviarán automáticamente en su fecha programada</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Tabla de Mensajes */}
      <div className="bg-white shadow-sm rounded-lg border border-gray-200 p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          Mensajes Programados
        </h2>
        <IndividualMessagesTable onPreview={handlePreview} />
      </div>

      {/* Modal de Preview */}
      <EmailPreviewModal
        message={selectedMessage}
        isOpen={previewOpen}
        onClose={handleClosePreview}
        type="message"
      />
    </div>
  );
}
